/**
 * Короткий звук уведомления без внешних файлов.
 */
export const playNotificationBeep = () => {
    try {
        const AudioCtx =
            window.AudioContext ||
            window.webkitAudioContext;

        if (!AudioCtx) {
            return;
        }

        const ctx = new AudioCtx();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();

        oscillator.type = 'sine';
        oscillator.frequency.value = 880;

        gain.gain.value = 0.0001;

        oscillator.connect(gain);
        gain.connect(ctx.destination);

        const now = ctx.currentTime;

        gain.gain.exponentialRampToValueAtTime(
            0.18,
            now + 0.02
        );
        gain.gain.exponentialRampToValueAtTime(
            0.0001,
            now + 0.35
        );

        oscillator.start(now);
        oscillator.stop(now + 0.4);

        oscillator.onended = () => {
            ctx.close().catch(() => {});
        };
    } catch (error) {
        console.warn(
            'notification beep failed',
            error
        );
    }
};

/** Двойной тон входящего сообщения в чате. */
export const playChatMessageSound = () => {
    try {
        const AudioCtx =
            window.AudioContext ||
            window.webkitAudioContext;

        if (!AudioCtx) {
            return;
        }

        const ctx = new AudioCtx();
        const now = ctx.currentTime;
        const playTone = (freq, start, dur) => {
            const oscillator = ctx.createOscillator();
            const gain = ctx.createGain();
            oscillator.type = 'sine';
            oscillator.frequency.value = freq;
            gain.gain.value = 0.0001;
            oscillator.connect(gain);
            gain.connect(ctx.destination);
            gain.gain.exponentialRampToValueAtTime(
                0.16,
                now + start + 0.02
            );
            gain.gain.exponentialRampToValueAtTime(
                0.0001,
                now + start + dur
            );
            oscillator.start(now + start);
            oscillator.stop(now + start + dur + 0.02);
        };

        playTone(880, 0, 0.16);
        playTone(1174, 0.18, 0.22);

        setTimeout(() => {
            ctx.close().catch(() => {});
        }, 600);
    } catch (error) {
        console.warn('chat sound failed', error);
    }
};

export const ensureBrowserNotifyPermission =
    async () => {
        if (
            typeof window === 'undefined' ||
            !('Notification' in window)
        ) {
            return 'unsupported';
        }

        if (Notification.permission === 'granted') {
            return 'granted';
        }

        if (Notification.permission === 'denied') {
            return 'denied';
        }

        try {
            return await Notification.requestPermission();
        } catch (error) {
            return 'denied';
        }
    };

export const showBrowserNotification = ({
    title,
    body,
    tag,
    onClick
}) => {
    if (
        typeof window === 'undefined' ||
        !('Notification' in window) ||
        Notification.permission !== 'granted'
    ) {
        return null;
    }

    try {
        const note = new Notification(
            title || 'CRM',
            {
                body: body || '',
                tag: tag || undefined,
                renotify: true
            }
        );

        if (typeof onClick === 'function') {
            note.onclick = event => {
                event.preventDefault();
                window.focus();
                onClick();
                note.close();
            };
        }

        return note;
    } catch (error) {
        console.warn(
            'browser notification failed',
            error
        );
        return null;
    }
};
